import { VariantAttributeFilter } from "@/types/product";

export const variantAttributeKeys = {
  all: ["variant-attributes"] as const,
  lists: () => [...variantAttributeKeys.all, "list"] as const,
  list: (workspaceId: string, filters: VariantAttributeFilter = {}) =>
    [...variantAttributeKeys.lists(), workspaceId, { filters }] as const,
  details: () => [...variantAttributeKeys.all, "detail"] as const,
  detail: (id: string) => [...variantAttributeKeys.details(), id] as const,
};
